var map = {
	"./asha-aware-2.jpg": "vss5",
	"./asha-aware.jpg": "OSu/",
	"./baby-weigh.jpg": "xg8S",
	"./bp-check-2.jpg": "kK0n",
	"./bp-check-3.jpg": "RLVN",
	"./bp-check.jpg": "BdnU",
	"./bp-happy.jpg": "ZiaY",
	"./care-bed.jpg": "HSx0",
	"./class.jpg": "YmIU",
	"./doc-muslim.jpg": "+JGl",
	"./doc-prescrip.jpg": "Gq0J",
	"./docs-sit.jpg": "d9dE",
	"./incubators.jpg": "ym+s",
	"./kid-inject.jpg": "sFe7",
	"./kid-vaccine.jpg": "IIjP",
	"./lab-technician.jpg": "17lt",
	"./patient-line-2.jpg": "JvmC",
	"./patient-line.jpg": "ufs2",
	"./shivir-2.jpg": "xpWa",
	"./shivir-3.jpg": "63Rv",
	"./shivir-4.jpg": "aJLd",
	"./shivir.jpg": "6u/w",
	"./sign-2.jpg": "BXmL",
	"./sign-3.jpg": "Z2gs",
	"./sign-4.jpg": "gCoM",
	"./sign.jpg": "w5N9",
	"./staff-uphc.jpg": "/I9Q"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "YJwR";


//////////////////
// WEBPACK FOOTER
// ./src/components/Projects/Uphc/Uphc-pics ^\.\/.*$
// module id = YJwR
// module chunks = 0